const URL_SERVER = 'https://api-vezha-production.up.railway.app';
const OK = 200;
const CREATED = 201;
const NoContent = 204;
const UNAUTHORIZED = 401;
const FORBIDDEN = 403;
const CONFLICT = 409;

export { URL_SERVER, OK, CREATED, FORBIDDEN, CONFLICT, UNAUTHORIZED, NoContent };
